import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
const Footer = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  return (
    <>
      
      <footer className="footer-section bg-light text-dark">
        <div className="container">
          <div className="row gx-5">
            <div className="col-lg-4 col-sm-6">
              <img
                src="/assets/images/logo-light/Mobile_logo.png"
                className="w-150px"
                alt=""
              />
              <div className="spacer-20"></div>
              <p>
                AtYourDoors Mobile Repairs: Convenience meets expertise. We
                offer on-the-spot mobile device repairs, bringing quality
                service to your doorstep. Quick, reliable, and hassle-free
                repairs to get your gadgets back in action
              </p>

              <div className="social-icons mb-sm-30">
                <a
                  href="https://www.facebook.com/people/AtyourDoor/61570062873490/"
                  target="blank_"
                >
                  <i className="fa-brands fa-facebook fa-lg"></i>
                </a>
                <a
                  href="https://www.instagram.com/atyourdoormobilerepairs/"
                  target="blank_"
                >
                  <i className="fa-brands fa-instagram fa-lg"></i>
                </a>
                <a href="#">
                  <i className="fa-brands fa-x-twitter fa-lg"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-sm-12 order-lg-1 order-sm-2">
              <div className="row">
                <div className="col-lg-6 col-sm-6">
                  <div className="widget ">
                    <h5 className="text-dark">Company</h5>
                    <ul>
                      <li>
                        <Link
                          className={` ${
                            currentPath === "/" ? "footer-links" : ""
                          }`}
                          to="/"
                        >
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={` ${
                            currentPath === "/aboutus" ? "footer-links" : ""
                          }`}
                          to="/aboutus"
                        >
                          About Us
                        </Link>
                      </li>

                      <li>
                        <Link
                          className={` ${
                            currentPath === "/blog" ? "footer-links" : ""
                          }`}
                          to="/blog"
                        >
                          Blog
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={` ${
                            currentPath === "/contact" ? "footer-links" : ""
                          }`}
                          to="/contact"
                        >
                          Contact Us
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6">
                  <div className="widget">
                    <h5 className="text-dark">Help / Support</h5>
                    <ul>
                      <li>
                        <Link
                          className={` ${
                            currentPath === "/faqs" ? "footer-links" : ""
                          }`}
                          to="/faqs"
                        >
                          FAQs
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={` ${
                            currentPath === "/privacy-policy"
                              ? "footer-links"
                              : ""
                          }`}
                          to="/privacy-policy"
                        >
                          Privacy & Policy{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={` ${
                            currentPath === "/term-condition"
                              ? "footer-links"
                              : ""
                          }`}
                          to="/term-condition"
                        >
                          Terms & Conditions
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={` ${
                            currentPath === "/gdpr-policy" ? "footer-links" : ""
                          }`}
                          to="/gdpr-policy"
                        >
                          GDPR Compliance
                        </Link>
                      </li>

                      <li>
                        <Link
                          className={` text-nowrap ${
                            currentPath === "/refund-policy"
                              ? "footer-links"
                              : ""
                          }`}
                          to="/refund-policy"
                        >
                          Shipping & Refund Policy
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 order-lg-2 order-sm-1">
              <div className="widget  ">
                <div className="fw-bold ">
                  <i className=" icofont-phone me-2 id-color-2"></i>Contact
                  Number
                </div>
                +91-9785440321
                <div className="spacer-20"></div>
                <div className="fw-bold ">
                  <i className="icofont-location-pin me-2 id-color-2"></i>
                  Workshop Location
                </div>
                Gaitor Road, Jagatpura, Jaipur, Rajasthan-302017
                <div className="spacer-20"></div>
                <div className="fw-bold ">
                  <i className="icofont-envelope me-2 id-color-2"></i>Send a
                  Message
                </div>
                support@atyourdoormobilerepairs.com
                <div className="spacer-20"></div>
                <div className="fw-bold">
                  <i className="icofont-wallet me-2 id-color-2"></i>Accepted
                  Payments
                </div>
                <div className="d-flex gap-4 mt-2 flex-wrap">
                  <img
                    src="/assets/images/payment/phonepe-icon.svg"
                    alt="PhonePe"
                    style={{ width: "30px", transition: "transform 0.3s ease" }}
                    className="hover-scale"
                  />
                  <img
                    src="/assets/images/payment/paytm.svg"
                    alt="Paytm"
                    style={{ width: "30px", transition: "transform 0.3s ease" }}
                    className="hover-scale"
                  />
                  <img
                    src="/assets/images/payment/google-pay.svg"
                    alt="Google Pay"
                    style={{ width: "30px", transition: "transform 0.3s ease" }}
                    className="hover-scale"
                  />
                  <img
                    src="/assets/images/payment/net-banking-icon.svg"
                    alt="Net Banking"
                    style={{ width: "30px", transition: "transform 0.3s ease" }}
                    className="hover-scale"
                  />
                  <img
                    src="/assets/images/payment/mastercard.svg"
                    alt="Net Banking"
                    style={{ width: "30px", transition: "transform 0.3s ease" }}
                    className="hover-scale"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="subfooter"
          style={{ backgroundColor: "#73b734", color: "white" }}
        >
          <div className="container">
            <div className="row ">
              <div className="col-md-12">
                <div className="de-flex justify-content-center">
                  <div className="de-flex-col text-white footer-copyright ">
                    ©Copyright 2024. www.atyourdoormobilerepairs.com . All Right
                    Reserved
                  </div>
                  <a  className="text-white ms-3" href="/sitemap.xml">sitemap</a>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </footer>
      
    </>
  );
};

export default Footer;
